import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiRoomService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiRoomService ]';
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  list(): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/rooms',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  getRoomPatients() {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/roomPatients',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * 登録処理
   * @param params
   */
  async post(params) {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/room`,
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  /**
   * 一括登録処理
   * @param params
   */
  async bulkPost(params) {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/room/bulk`,
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  /**
   * 更新処理
   * @param params
   */
  update(params, message = null) {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/rooms/${params._id}`,
        body: params, headers: this.headers
      }, message).subscribe(response => resolve(response))
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-room.service.ts